import { useAtomValue } from 'jotai'

import {
  invoiceCurrencyAtom,
  invoicePaymentsAtom
} from 'Invoices/atoms/invoiceEditing.atom'
import { Section } from '../../components'
import { PaymentsList } from './PaymentsList'

export const Payments = () => {
  // Current payments are served on the invoice, so no separate fetch: a
  // recorded payment invalidates INVOICES, which refreshes them here.
  const payments = useAtomValue(invoicePaymentsAtom)
  const currency = useAtomValue(invoiceCurrencyAtom) ?? 'USD'

  // Hidden entirely until there is at least one payment, rather than showing an
  // empty table.
  if (payments.length === 0) return null

  return (
    <Section title="Payments" data-testid="invoice.payments">
      <PaymentsList payments={payments} currency={currency} />
    </Section>
  )
}
